export default __webpack_public_path__ + "static/favicon-8e7550b1c8c58df07071a70aeb46fd3f.ico";